export const MODAL_LOADER_Z_INDEX = 1301;
